import React, { useEffect,useState } from 'react';
import { useSelector } from 'react-redux';
import { useFetchTransfers } from '../../../../../../../../jsx/hooks/getTransfers';
import { ListLayout } from '../../containers/Layout';
import { isEmpty } from 'lodash';
import { TableRow, TableCell, Button, TableHead, TableBody, IconButton } from '@material-ui/core';
import { AddRounded, DeleteRounded } from '@material-ui/icons';
import Currency from '../../../../../commonModules/Currency';
import TableFooterPagination from '../../../../../commonModules/interface/TableFooterPagination';

const ListTransferReapproExt = (props) => {
    const fetchTransfers = useFetchTransfers("reapprovisionnement_ext");
    const REAPPRO_EXT = useSelector((state) => state.inventory.sales.REAPPRO_EXT); 
    const SHOPS = useSelector((state) => state.inventory.shops); 
	const STATE = useSelector((state) => state.inventory.requestState); 
    const [reapproextList, setReapproextList] = useState([]);
    const [reapproextListInitial, setReapproextListInitial] = useState([]);
    const [currentPage,setCurrentPage] = useState(0);
    const [pageOfItems,setPageOfItems] = useState(20);

    useEffect(() => {
        console.log("MOUNTING ListTransferReapproExt");
        if (isEmpty(REAPPRO_EXT)){
            fetchTransfers();
        }else{
            createInitialList()
        }
    }, []);

    const createInitialList = ()=>{
        const reapproInitialList = createReapproList();
        setReapproextListInitial(reapproInitialList)
        console.log("MOUNTING ListTransferReapproExt REAPPRO_EXT",reapproInitialList.length,pageOfItems,currentPage+1);

        setReapproextList(reapproInitialList.slice(0,pageOfItems*(currentPage+1)))
    }

    useEffect(() => {
        console.log("MOUNTING ListTransferReapproExt REAPPRO_EXT");
        createInitialList()
    }, [REAPPRO_EXT]);

    const onChangePage = (pageOfItemsTmp, page,rowsPerPage) =>{
        let rowsPerPageVal = 0
        console.log("onChangePage >",pageOfItems,"-",page,"-",rowsPerPage)
        if (!(typeof rowsPerPage === "undefined")){
            setPageOfItems(rowsPerPage)
            rowsPerPageVal=rowsPerPage
        }else{
            rowsPerPageVal=pageOfItems
        }
        setCurrentPage(page)
        if (page >=0){
            console.log("onChangePage >>>>",page,"-",rowsPerPageVal)

            setReapproextList(reapproextListInitial.slice(rowsPerPageVal*(page),rowsPerPageVal*(page+1)))
        }
    }

    const createReapproList = () => {
        if (!REAPPRO_EXT) {
            return [];
        }

        return Object.values(REAPPRO_EXT).map(reappro => {
            const shop = SHOPS[reappro.shop_id];
            // Utiliser le prix de revient si disponible, sinon calculer avec TTC
            const total = reappro.prix_revient || 
                        ((reappro.total_price_TTC || reappro.total_price) + (reappro.taxes || 0) + (reappro.transport || 0));
            return (
                <TableRow key={reappro.id}>
                    <TableCell>{new Date(reappro.creation_date).toLocaleString('fr-FR')}</TableCell>
                    <TableCell>
                        <a href="#" onClick={() => props.handleSingleShop(shop)}>
                            {shop && shop.name}
                        </a>
                    </TableCell>
                    <TableCell>{reappro.comments}</TableCell>
                    <TableCell>
                        <Currency value={total} />
                    </TableCell>
                    <TableCell>
                        <IconButton color="secondary" onClick={() => props.handleSingleReaExtern(reappro, shop)}>
                            <AddRounded />
                        </IconButton>
                    </TableCell>
                    <TableCell>
                        <IconButton onClick={() => props.handleDelete(reappro)}>
                            <DeleteRounded color="error" />
                        </IconButton>
                    </TableCell>
                </TableRow>
            );
        });
    };

    return (
        <ListLayout>
            <TableHead>
                <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Shop</TableCell>
                    <TableCell>Remarques</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Détails</TableCell>
                    <TableCell>Options</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                    { reapproextList.length !== 0  && 
                        reapproextList
                    }
                    { reapproextList.length === 0  && 
                    <TableRow>
                        <TableCell colSpan="6">
                            <div className="text-center">
                                <h5>Pas de Reapprovisionnement externe</h5>
                                Cliquez sur <b className="onglet">"Nouveau"</b> Pour en créer un
                            </div>
                        </TableCell>
                    </TableRow>
                }
            </TableBody>
            { reapproextListInitial.length > 20  && 
                    <TableFooterPagination 
                        colSpan={7}
                        // items={saleList[0]} 
                        count={reapproextListInitial.length}
                        onChangePage={onChangePage}
                        initialPage={currentPage || 0}
                        page={currentPage}
                    />         
               }    
        </ListLayout>
    );
};

export default ListTransferReapproExt;
